/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const feverdream: CommunityData = {
  code: "feverdream",
  inviteCode: "feverdream",
  name: "Feverdream",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/feverdream`,
  socials: {},
  styles: {
    global: {
      counterColor: "#FFFFFF",
      logo: {
        src: "/assets/customizations/feverdream/logo.png",
        styles: "w-[127px]",
      },
      alternativeLogo: {
        src: "/assets/customizations/feverdream/logo.png",
        styles: "w-[158px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[1px] border-[#565656] rounded-[9px]",
      bgColor: "#151313",
      asideBg: "#151313",
      asideStyles: "border-r-[#000000] border-r",
      contentBg: "#151313",
      bgDesktop: "/assets/customizations/feverdream/bg.png",
      bgMobile: "/assets/customizations/feverdream/bg.png",
      mainFont: "font-['WrathStyles']",
      primaryButton:
        "flex mt-2 !text-[#FFFFFF] rounded-full justify-center items-center !text-[20px] pt-1 !h-[44px] bg-[#151515] border-[#565656] border-[1px] !px-[32px] sm:!min-w-[156px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#A30000",
      separator: "border-t-[#404040] border-t",
      item: "text-[24px] text-[#FFFFFF] h-[40px] flex sm:justify-start justify-center items-center sm:!pt-2 !pt-6",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      titles: "text-[36px] text-[#FFFFFF] leading-[40px]",
      announcements: {
        lg: {
          subtitle:
            "!text-[16px] px-[6px] !pt-[6px] !bg-[#000000] !text-[#FFFFF] font-['FanwoodText'] w-fit h-[19px] flex items-center",
          title:
            "leading-[25px] !text-[20px] -mb-1 mt-[-4px] px-[6px] w-fit h-[19px] flex items-center",
        },
        sm: {
          subtitle:
            "!text-[16px] px-[6px] !pt-[6px] !bg-[#000000] !text-[#FFFFF] font-['FanwoodText'] w-fit h-[19px] flex items-center",
          title: "!text-[20px] leading-[25px] mt-[-4px] px-[6px] w-fit h-[19px] flex items-center",
        },
      },
      event: {
        title: "text-[#FFFFFF] text-[24px] one-line-truncate",
        subtitle: "text-[#FFFFFF] font-['FanwoodText'] text-[16px] leading-[16px]",
      },
      shop: {
        title: "text-[24px] text-[#FFFFFF] leading-[28px]",
        text: "text-[#FFFFFF] font-['FanwoodText'] text-[20px] leading-[26px]",
        customShopImage: "",
      },
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
    },
    announcements: {
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[16px] text-[#A30000] leading-[35px] uppercase font-bold",
      created: "text-[#FFFFFF] font-['FanwoodText'] text-[18px] leading-[22px]",
      title: "text-[28px] text-[#FFFFFF] leading-[42px]",
      description: "text-[#FFFFFF] font-['FanwoodText'] text-[18px] leading-[22px]",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
    },
    announcement: {
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      created: "text-[#FFFFFF] font-['FanwoodText'] text-[18px] leading-[22px]",
      title: "text-[28px] text-[#FFFFFF] leading-[42px]",
      description: "text-[#FFFFFF] font-['FanwoodText'] text-[18px] leading-[22px]",
      likeCount: "text-[#FFFFFF]",
      likeIconColor: "#FFFFFF",
      commentCount: "text-[#FFFFFF]",
      commentIconColor: "#FFFFFF",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
    },
    events: {
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[36px] text-[#FFFFFF] leading-[40px]",
      sectionHeader: "text-[#FFFFFF] text-[28px] leading-[32px]",
      title: "text-[28px] text-[#FFFFFF] leading-[42px]",
      duration: "font-['FanwoodText'] text-[#FFFFFF] leading-[22px] !text-[16px]",
      address: "font-['FanwoodText'] text-[#FFFFFF] leading-[22px] !text-[16px]",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#FFFFFF]",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState: "text-[#FFFFFF] text-[14px]",
      header: "text-[28px] text-[#FFFFFF] leading-[32px] !mt-0 sm:mb-0 mb-[24px]",
      sectionSubtitle: "font-['FanwoodText'] text-[#FFFFFF] leading-[22px] !text-[18px]",
      sectionTitle: "text-[#FFFFFF] text-[28px] leading-[32px]",
      text: "text-[#FFFFFF] font-['FanwoodText'] text-[18px] leading-[22px]",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#FFFFFF]",
      map: {
        pin: "",
        border: "mb-2 border-[1px] border-[#FFFFFF] overflow-hidden",
        pinColor: "#FFFFFF",
        strokeColor: "#FFFFFF",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "text-[#FFFFFF] !mt-0 text-[28px] leading-[32px]",
        subtitle: "font-['FanwoodText'] text-[#FFFFFF] leading-[22px] !text-[18px]",
      },
      ticket: {
        title: "text-[28px] text-[#FFFFFF] leading-[32px]",
        description: "font-['FanwoodText'] text-[18px] leading-[15px] capitalize",
        text: "font-['FanwoodText'] capitalize text-[15px] leading-[22px]",
        price: "text-[28px] text-[#FFFFFF] font-['FanwoodText']",
        counterContainer: "text-[20px] !text-[#FFFFFF] rounded-[8px] !border-[#565656]",
        quantity: "text-nowrap text-[#FFFFFF] pt-1 rounded-[8px] text-[16px] !border-[#565656]",
      },
      separator: "sm:my-8 my-6 border-b-[#FFFFFF] border-b-[1px]",
    },
    shop: {},
    linktree: {
      container:
        "font-['WrathStyles'] flex flex-col items-center h-full w-full bg-cover min-h-screen relative bg-[#000000] p-[64px]",
      bgDesktop: "/assets/customizations/feverdream/bg-linktree.png",
      bgMobile: "/assets/customizations/feverdream/bg-linktree.png",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[#FFFFFF] border-[2px]",
        name: "text-[28px] text-[#FFFFFF] mt-2",
        location: "font-['FanwoodText'] text-[#FFFFFF] text-[18px] leading-[22px] text-center mb-2",
        description:
          "font-['FanwoodText'] text-[#FFFFFF] text-[18px] leading-[22px] text-center mb-4",
        socialMediaIconColor: "#FFFFFF",
        button:
          "flex mt-2 !text-[#FFFFFF] rounded-full justify-center items-center !text-[20px] pt-1 !h-[63px] bg-[#151515] border-[#565656] border-[1px] !px-[32px] text-nowrap cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[42px] text-[#FFFFFF] border-[1px] border-[#565656] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#151515] items-center text-[24px]",
        emptyState: {
          container:
            "rounded-[9px] border-[#89A6CC] border-[1px] sm:w-[500px] w-[95vw] bg-[#151515] flex justify-between flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title: "text-[24px] !text-[#FFFFFF]",
          text: "font-['FanwoodText'] text-[18px] !text-[#FFFFFF]",
          button:
            "flex mt-2 !text-[#FFFFFF] rounded-full justify-center items-center !text-[20px] pt-1 !h-[50px] bg-[#151515] border-[#565656] border-[1px] !px-[24px] text-nowrap cursor-pointer w-fit mt-2",
        },
        header: "text-[28px] leading-[32px] !text-[#FFFFFF] mb-[10px] text-center w-screen",
        container: "gap-4 flex flex-col items-center",
        event: {
          container:
            "overflow-hidden rounded-[9px] border-[#565656] border-[1px] bg-[#151515] sm:w-[500px] w-[95vw]",
          name: "text-[24px] text-[#FFFFFF] leading-[28px] mb-1 sm:w-[390px] w-[65vw]",
          duration: "font-['FanwoodText'] text-[13px] leading-[21px] uppercase text-[#FFFFFF]",
          location: "text-[13px] !font-['FanwoodText'] leading-[21px] mb-4 text-[#FFFFFF]",
          startDate:
            "!w-[64px] border-[#565656] border-[1px] rounded-[9px] text-[#F6F4E7] text-[24px] h-[64px] bg-[#151515] flex flex-col justify-center items-center gap-1",
          button:
            "flex mt-2 !text-[#FFFFFF] rounded-full justify-center items-center !text-[20px] pt-1 !h-[50px] bg-[#151515] border-[#565656] border-[1px] !px-[24px] text-nowrap cursor-pointer w-fit",
          product: {
            container:
              "h-[73px] border-t border-t-[#565656] px-4 items-center flex justify-between",
            name: "text-[24px] text-[#FFFFFF] leading-[28px] mb-1 one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[18px] leading-[22px] font-['FanwoodText'] text-[#FFFFFF]",
            status: "text-[15px] leading-[22px] text-[#FFFFFF]",
            link: "text-[14px] font-medium text-[#A30000]",
            button:
              "flex mt-2 !text-[#FFFFFF] rounded-full justify-center items-center !text-[20px] pt-1 !h-[50px] bg-[#151515] border-[#565656] border-[1px] !px-[24px] text-nowrap cursor-pointer w-fit",
          },
        },
        collapsedEvent: {
          container:
            "h-[69px] rounded-[9px] border-[#565656] border-[1px] bg-[#151515] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between pr-2",
          name: "text-[24px] text-[#FFFFFF] leading-[24px] pt-[2px] sm:w-[390px] w-[65vw]",
          duration: "font-['FanwoodText'] !text-[13px] mt-[-2px] uppercase text-[#FFFFFF]",
          plusIconColor: "#FFFFFF",
          media: "overflow-hidden m-2",
        },
        seeAllEvents:
          "text-[18px] text-[#FFFFFF] underline font-['FanwoodText'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[42px] text-[#FFFFFF] border-[1px] border-[#565656] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#151515] items-center text-[24px]",
        header: "text-[28px] leading-[32px] !text-[#FFFFFF] mb-[10px] text-center w-screen",
        oneNews: {
          container:
            "pr-2 overflow-hidden rounded-[9px] border-[#565656] border-[1px] bg-[#151515] h-[85px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between",
          name: "text-[#FFFFFF] mt-[2px] !text-[24px] leading-[28px] mb-1 one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#FFFFFF",
          created: "text-[15px] leading-[21px] mt-[-4px] text-[#FFFFFF]",
          media: "overflow-hidden w-[48px] h-[48px] ml-[16px] mr-2 my-[18.5px]",
        },
        seeAllNews:
          "text-[18px] text-[#FFFFFF] underline font-['FanwoodText'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        container: "flex flex-col gap-[10px] mb-[40px]",
        loadingState:
          "mb-[42px] text-[#FFFFFF] border-[1px] border-[#565656] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#151515] items-center text-[24px]",
        header: "text-[28px] leading-[32px] !text-[#FFFFFF] mb-[10px] text-center w-screen",
        link: {
          container:
            "h-[60px] rounded-[9px] border-[1px] border-[#565656] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#151515]",
          name: "text-[24px] text-[#FFFFFF] leading-[28px] mb-[6px] mt-[8px] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#FFFFFF",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "uppercase font-mono text-[11px] font-bold text-[#FFFFFF]",
      },
    },
  },
}

export default feverdream
